import React from 'react';
import Text from '@rexlabs/text';

const SubHeading = (props) => (
  <Text is='h2' {...props} type={['SUB_HEADING']} />
);
export default SubHeading;
